export type StartEndTimeMode = 'manual' | 'live';

type MapLinkParams = {
  date: string;
  officeId?: string;
  resourceId?: string;
  floorId?: string;
  startTime?: string;
  endTime?: string;
  timeMode?: StartEndTimeMode;
  searchText?: string;
  section?: 'people' | 'rooms' | 'desks' | 'other';
};

export const createMapLink = ({
  date,
  officeId,
  resourceId,
  floorId,
  startTime,
  endTime,
  timeMode = 'manual',
  searchText,
  section = 'people'
}: MapLinkParams) => {
  let link = `/map#date=${date.split('T')[0]}`;
  if (officeId) {
    link = `${link}&officeId=${officeId}`;
  }
  if (floorId) {
    link = `${link}&floorId=${floorId}`;
  }
  if (resourceId) {
    link = `${link}&resource=${resourceId}`;
  }
  if (startTime) {
    link = `${link}&startTime=${startTime}`;
  }
  if (endTime) {
    link = `${link}&endTime=${endTime}`;
  }
  if (timeMode) {
    link = `${link}&timeMode=${timeMode}`;
  }
  if (searchText) {
    link = `${link}&searchText=${searchText}`;
  }
  if (section) {
    link = `${link}&section=${section}`;
  }
  return link;
};
